import { useState } from 'react';
import { TableBlockType, TableModeType } from '../../../../types';
import { TABLE_MODE } from '../../../../constants/generalConstants';
import { ROLES } from '../../../../../../../constnats/user';
import AuthService from '../../../../../../../service/auth';
import LabeledDropdown from '../labeledDropdown';
import { getOptions } from '../../../../utils/tableExtraction';
import { SUPPORTED_FIELD_VALUES } from '../../constants';
import ColumnInclusionControl from './components/columnInclusionControl';
import ColumnMetadataForm from './components/columnMetadataForm';
import RowInclusionControl from './components/rowInclusionControl';
import RowContentTypeControl from './components/rowContentTypeControl';
import AnnotationsTableCell from './components/annotationsTableCell';
import RowsInclusionToggle from './components/rowsInclusionToggle';
import ColumnInclusionToggle from './components/columnInclusionToggle';
import AnnotationsTableRow from './components/annotationsTableRow/annotationsTableRow';

type AnnotationsTablePropsType = {
    table: TableBlockType;
};

function AnnotationsTable({ table }: AnnotationsTablePropsType) {
    const [mode, setMode] = useState<TableModeType>(TABLE_MODE.NORMAL);

    return (
        <>
            <div className="flex flex-gap-1 mb-05">
                {AuthService.hasGlobalRole(ROLES.ADMIN) && (
                    <LabeledDropdown
                        label="Mode"
                        placeholder="Mode"
                        value={mode}
                        upward={false}
                        options={getOptions(SUPPORTED_FIELD_VALUES.TABLE_MODES)}
                        onChange={(__, data) => setMode(data.value as TableModeType)}
                    />
                )}
            </div>

            <table className="extraction-table">
                <thead>
                    <tr>
                        <th />
                        <th>
                            <ColumnInclusionToggle tableId={table.id} />
                        </th>
                        {table.rows[0].cells.map((cell) => {
                            const colId = cell.collId;
                            return (
                                <th key={colId}>
                                    <ColumnInclusionControl colId={colId} />
                                </th>
                            );
                        })}
                    </tr>
                    <tr>
                        <th>
                            <RowsInclusionToggle tableId={table.id} />
                        </th>
                        <th />
                        {table.rows[0].cells.map((cell) => {
                            const colId = cell.collId;
                            return (
                                <th key={colId}>
                                    <ColumnMetadataForm colId={colId} />
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {table.rows.map((row) => {
                        const rowId = row.id;
                        return (
                            <AnnotationsTableRow key={rowId} rowId={rowId}>
                                <th>
                                    <RowInclusionControl rowId={rowId} />
                                </th>
                                <th>
                                    <RowContentTypeControl rowId={rowId} />
                                </th>
                                {row.cells.map((cell) => {
                                    return <AnnotationsTableCell key={cell.id} cell={cell} mode={mode} rowId={rowId} />;
                                })}
                            </AnnotationsTableRow>
                        );
                    })}
                </tbody>
            </table>
        </>
    );
}

export default AnnotationsTable;
